import React, { useEffect, useState } from "react";
import { getConfirmAlert } from "../../../Services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import MUIButton from '@mui/material/Button';
import Check from "@mui/icons-material/Check";
import Cancel from "@mui/icons-material/Cancel";
import Save from "@mui/icons-material/Save";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import ArrowForward from "@mui/icons-material/ArrowForward";
import ArrowBack from "@mui/icons-material/ArrowBack";
import HelpOutline from "@mui/icons-material/HelpOutline";
import CancelIcon from '@mui/icons-material/Cancel';
import { getButtonAlertMessages, loadButtonAlertMessages } from "../../store/layoutUI";

const Button = (props) => {
    const { comp,
        btnProcessStatus,
        isDisabled,
        setIsDisabled,
        isEdit,
        validate,
        doSubmit,
        handleClose,
        size = "btn-sm",
        currentButtonType
    } = props;

    const [alertMessages, setAlertMessages] = useState([]);
    const buttonAlertMessagesSelector = useSelector(getButtonAlertMessages);
    const dispatch = useDispatch();
    useEffect(() => {
        if (comp?.formProcess > 0)
            dispatch(loadButtonAlertMessages(comp.formProcess));
    }, []);

    useEffect(() => {
        setAlertMessages(buttonAlertMessagesSelector);
    }, [buttonAlertMessagesSelector])

    // console.log(isDisabled, "isDisabled")

    if (!comp) return;

    const closeBtn = ["close", "exit", "back"];
    const saveBtn = ["submit", "saveAndContinue", "saveAndExit", "save", "taskCompleted", "checkStatus", "home"];
    const updBtn = ["update", "updateAndContinue", "updateAndExit"];

    const commonButtonStyle = {
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
        minHeight: "37px",
        height: "37px",
        textTransform: "none",
    };

    const handleSubformModalShowHide = (name) => {
        const modelId = name.split("-");
        if (modelId.length > 1)
            this.setState({
                [modelId[0]]: !this.state[modelId[0]],
                subformItemIndex: modelId[1],
            });
        else this.setState({ [name]: !this.state[name], subformItemIndex: -1 });
    };

    const handleEditForm = async () => {
        const result = await getConfirmAlert("Are you sure?", "You want to Edit this Form", "warning");
        if (result.isConfirmed)
            setIsDisabled(false)
    };

    const handleSubmit = async (e) => {
        const targetval = e.currentTarget;
        e.preventDefault();
        const processId = targetval.dataset.process;
        if (parseInt(processId) > 0) {
            const msg = alertMessages.filter(x => x.formProcessId === parseInt(processId));
            if (msg.length > 0) {
                const alMsg = msg[0];
                if (alMsg.isConfirmMessage) {
                    const result = await getConfirmAlert("", alMsg.processItem, "warning");
                    if (result.isConfirmed) {
                        doSubmit(targetval, "Saved Successfully");
                    }
                } else {
                    doSubmit(targetval, alMsg.processItem);
                }
            }
            else {
                doSubmit(targetval, "");
            }
        }
        else {
            doSubmit(targetval, "");
        }

    };

    const getButtonStyle = (style) => {
        const styles = [
            "secondary",
            "success",
            "danger",
            "warning",
            "info",
            "light",
            "dark",
        ];

        for (let s of styles) {
            if (style.includes(s)) {
                return s;
            }
        }

        return "primary";
    }

    const getMUIButtonProps = (style = "") => {
        const props = {
            color: "primary",
            size: "medium",
            variant: "contained"
        };

        if (style.includes("danger")) props.color = "error";
        else if (style.includes("success")) props.color = "success";
        else if (style.includes("warning")) props.color = "warning";
        else if (style.includes("info")) props.color = "info";
        else if (style.includes("secondary")) props.color = "secondary";
        else if (style.includes("primary")) props.color = "primary";
        else if (style.includes("dark")) props.color = "inherit";

        if (style.includes("outline")) props.variant = "outlined";
        else props.variant = "contained";

        if (style.includes("btn-sm")) props.size = "small";
        else if (style.includes("btn-lg")) props.size = "large";

        return props;
    };

    const mapFAIconToMUI = (faClass = "") => {
        if (faClass.includes("fa-check")) return <Check />;
        if (faClass.includes("fa-times") || faClass.includes("fa-close")) return <Cancel />;
        if (faClass.includes("fa-save")) return <Save />;
        if (faClass.includes("fa-edit")) return <Edit />;
        if (faClass.includes("fa-trash")) return <Delete />;
        if (faClass.includes("fa-plus")) return <Add />;
        if (faClass.includes("fa-arrow-right")) return <ArrowForward />;
        if (faClass.includes("fa-arrow-left")) return <ArrowBack />;
        if (faClass.includes("fa-question")) return <HelpOutline />;
        if (faClass.includes("fa-spinner fa-spin")) return <HelpOutline />;
        return null;
    };

    if (comp.buttonType?.type === "subform") {
        return (
            <button
                type="button"
                onClick={() => handleSubformModalShowHide("showHide" + comp.subform)}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                disabled={isDisabled}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-1`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (comp.buttonType.type === "editForm") {
        const muiButtonProps = getMUIButtonProps(comp.style);
        return (
            <MUIButton
                variant={muiButtonProps.variant}
                color={muiButtonProps.color}
                name={comp.buttonType.type}
                size={muiButtonProps.size}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`form-group ${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                onClick={handleEditForm}
                aria-label={comp.label}
                sx={{
                    ...commonButtonStyle,
                    mr: 1,
                    mb: 1,
                    textTransform: "none",
                    ...(comp?.style?.includes("default") && {
                        backgroundColor: muiButtonProps.variant === "outlined" ? "transparent" : "#172b4d",
                        color: "#172b4d",
                        border: `1px solid #172b4d`,
                        '&:hover': {
                            backgroundColor: "#172b4d",
                            borderColor: "#172b4d",
                            color: "#fff"
                        },
                    }),
                    ...(muiButtonProps.variant === "outlined" &&
                        !comp?.style?.includes("default") && {
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette[muiButtonProps.color || "primary"].main,
                            color: (theme) => theme.palette[muiButtonProps.color || "primary"].contrastText,
                        },
                    }),
                    "&.Mui-disabled": {
                        backgroundColor:
                            muiButtonProps.variant === "outlined"
                                ? "#dfdbdb"
                                : "#dfdbdb",
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </MUIButton>
        );
    }

    if (comp.buttonType.type === "help") {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                //disabled={this.validate()}
                //onClick={this.handleSubmit}
                aria-lable={comp.label}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (closeBtn.indexOf(comp.buttonType.type) > -1) {
        // const muiButtonProps = getMUIButtonProps(comp.style);
        return (
            // <button
            //     type="button"
            //     name={comp.buttonType.type}
            //     data-process={comp?.formProcess ? 0 : comp.formProcess}
            //     className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
            //     onClick={handleClose}
            //     aria-label={comp.label}
            // >
            //     {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
            //     {comp.label}
            // </button>
            <MUIButton
                variant={"contained"}
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                onClick={handleClose}
                className={`${comp?.cssclass}`}
                sx={{
                    ...commonButtonStyle,
                    color: "#172b4d",
                    border: `1px solid #172b4d`,
                    '&:hover': {
                        backgroundColor: "#172b4d",
                        borderColor: "#172b4d",
                        color: "#fff"
                    },
                    mr: 1,
                    mb: 1,
                    textTransform: "none",
                    "&.Mui-disabled": {
                        backgroundColor: "#9e9e9e",
                        color: "#333333",
                        opacity: 1,
                    },
                }}
                startIcon={comp?.formIcons ? mapFAIconToMUI(comp.formIcons) : <CancelIcon />}

            >
                {comp?.formIcons && mapFAIconToMUI(comp.formIcons)}
                {comp.label}
            </MUIButton>
        );
    }

    if (saveBtn.indexOf(comp.buttonType.type) > -1) {
        // return (
        //     (!isEdit || isEdit === true || isDisabled) && (
        //         <button
        //             type="button"
        //             name={comp.buttonType.type}
        //             className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
        //             disabled={btnProcessStatus || isDisabled}
        //             onClick={handleSubmit}
        //             aria-label={comp.label}
        //             data-process={comp?.formProcess}
        //         >
        //             {btnProcessStatus && currentButtonType === comp.buttonType.type && <i className="fa fa-spinner fa-spin mr-2"></i>}
        //             {((!btnProcessStatus && comp?.formIcons) || (currentButtonType !== comp.buttonType.type)) && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
        //             {comp.label}
        //         </button>
        //     )
        // );

        const muiButtonProps = getMUIButtonProps(comp.style);
        //console.log(isDisabled, "isDisabled in saveBtn");
        //console.log(isEdit, "isEdit in saveBtn");
        //console.log(btnProcessStatus, "btnProcessStatus in saveBtn");

        return (!isEdit || isEdit === true || isDisabled)
            && <MUIButton
                variant={muiButtonProps.variant}
                color={muiButtonProps.color}
                name={comp.buttonType.type}
                size={muiButtonProps.size}
                onClick={handleSubmit}
                data-process={comp?.formProcess}
                className={`${comp?.cssclass}`}
                data-formId={!comp?.subform ? 0 : comp.subform}
                disabled={btnProcessStatus || (isDisabled && (isEdit === true || !isEdit) && isEdit !== false) || validate()}
                sx={{
                    ...commonButtonStyle,
                    mr: 1,
                    mb: 1,
                    textTransform: "none",
                    ...(comp?.style?.includes("default") && {
                        backgroundColor: muiButtonProps.variant === "outlined" ? "transparent" : "#172b4d",
                        color: "#172b4d",
                        border: `1px solid #172b4d`,
                        '&:hover': {
                            backgroundColor: "#172b4d",
                            borderColor: "#172b4d",
                            color: "#fff"
                        },
                    }),
                    ...(muiButtonProps.variant === "outlined" &&
                        !comp?.style?.includes("default") && {
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette[muiButtonProps.color || "primary"].main,
                            color: (theme) => theme.palette[muiButtonProps.color || "primary"].contrastText,
                        },
                    }),
                    "&.Mui-disabled": {
                        backgroundColor:
                            muiButtonProps.variant === "outlined"
                                ? "#dfdbdb"
                                : "#dfdbdb",
                        color: "#333333",
                        opacity: 1,
                    },
                }}
            >
                {btnProcessStatus && currentButtonType === comp.buttonType.type && <CircularProgress size={16} color="inherit" />}
                {((!btnProcessStatus && comp?.formIcons) || (currentButtonType !== comp.buttonType.type)) && mapFAIconToMUI(comp.formIcons)}
                {comp.label}
            </MUIButton>

    }

    if (updBtn.indexOf(comp.buttonType.type) > -1) {
        //console.log(isDisabled, "isDisabled in saveBtn");
        //console.log(isEdit, "isEdit in saveBtn");
        //console.log(btnProcessStatus, "btnProcessStatus in saveBtn");
        const muiButtonProps = getMUIButtonProps(comp.style);
        return (!isEdit && isEdit === false && !isDisabled && (
            // <button
            //     type="button"
            //     name={comp.buttonType.type}
            //     data-process={comp?.formProcess ? 0 : comp.formProcess}
            //     className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
            //     disabled={btnProcessStatus}
            //     onClick={handleSubmit}
            //     aria-lable={comp.label}
            //     sx={{
            //         mr: 1,
            //         mb: 1,
            //         textTransform: "none",
            //         "&.Mui-disabled": {
            //             backgroundColor: "#9e9e9e",
            //             color: "#333333",
            //             opacity: 1,
            //         },
            //     }}
            // >
            //     {btnProcessStatus && <i className="fa fa-spinner fa-spin mr-2"></i>}
            //     {!btnProcessStatus && comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
            //     {comp.label}
            // </button>
            <MUIButton
                variant="contained"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                onClick={handleSubmit}
                disabled={isDisabled || btnProcessStatus}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                sx={{
                    ...commonButtonStyle,
                    color: "#172b4d",
                    border: `1px solid #172b4d`,
                    '&:hover': {
                        backgroundColor: "#172b4d",
                        borderColor: "#172b4d",
                        color: "#fff"
                    },
                    mr: 1,
                    mb: 1,
                    textTransform: "none",
                    "&.Mui-disabled": {
                        backgroundColor: "#9e9e9e",
                        color: "#fff",
                        opacity: 1,
                    },
                }}
                startIcon={
                    btnProcessStatus
                        ? <CircularProgress size={16} color="inherit" />
                        : comp?.formIcons && mapFAIconToMUI(comp.formIcons)
                }
            >
                {comp.label}
            </MUIButton>
        )
        );
    }

    return "";
}

export default Button;